export function generateRandomNumber(length) {
  let result = "";
  result += Math.floor(Math.random() * 9) + 1;
  for (let i = 1; i < length; i++) {
    result += Math.floor(Math.random() * 10);
  }
  return result;
}

export function calculateCheckDigit(code) {
  let sum = 0;
  for (let i = 0; i < code.length; i++) {
    let num = parseInt(code[i]);
    sum += i % 2 === 0 ? num : num * 3;
  }
  let remainder = sum % 10;
  return remainder === 0 ? 0 : 10 - remainder;
}
